import PageSwitcher from './page-switcher';

export default PageSwitcher;
